import styled from 'styled-components';

import { hideAccessibleCheckmark } from 'DesignLibrary/utils';

export const LocationLabel = styled.label`
  cursor: pointer;

  input[type='radio'] {
    ${hideAccessibleCheckmark}
  }

  .pseudo-radio:hover {
    background: var(--colors-opaque-10);
  }

  .tag {
    padding: 4px 12px 4px 8px;
    border-radius: 1rem;
    background: #e1f7f2;
    max-width: 194px;

    label {
      text-transform: none;
      /* overriding label defaults */
      font-weight: 300 !important;
    }

    svg {
      fill: #01755b;
    }
  }
`;
